import React, { useEffect } from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import PrivacyPolicyContent from './components/PrivacyPolicyContent'

function PrivacyPolicy() {
  useEffect(() => {
    document.title = 'Agência Dorac - Política de Privacidade'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className='relative w-full bg-dorac-bg font-display text-dorac-ink'>
      <Header />
      <PrivacyPolicyContent />
      <Footer />
    </main>
  )
}

export default PrivacyPolicy
